import { isDev, version } from '../env'
import Libhoney from 'libhoney'

const honey = new Libhoney({
  writeKey: 'd5ac56c95833cbd2831a75b0399b6d37',
  dataset: 'printing_events',
  disabled: isDev,
})

export const sendEvent = async (ipc, eventBody) => {
  let version = null
  try {
    version = await ipc.invoke('shell-version')
  } catch (e) {
    ipc.send('log', '"shell-version" handler not registered')
  }

  honey.sendNow({
    app: 'workstation',
    version,
    ...eventBody,
  })
}
